<header class="bg-image bg-image-sec">
    <nav class="navbar navbar-expand-lg navbar-light fixed-top bg-white shadow-sm">
        <div class="container">
            <a class="navbar-brand" routerLink="/">
                <!-- <img src="../../../../assets/images/header-logo.png" /> -->
                <img src="../../../assets/images/enl-solutions-logo-new.png" class="enl-logo" />
            </a>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav ml-auto"></ul>
                <div class="form-inline my-2 my-lg-0">
                </div>
            </div>
        </div>
    </nav>
</header>

<section class="login-section">
    <div class="login-section-inner">
        <div class="login-left">
            <h2>HI!</h2>
            <div class="login-acc">
                Eail verification error
            </div>
        </div>
        <div class="login-right">
            <div>
                <div class="row">
                    <div class="col-md-12">
                        <img src="../../../assets/images/enl-solutions-logo-new.png" class="enl-logo" />
                    </div>
                    <div class="col-md-12">
                        <div class="form-group">
                            <h4>Your email varification link has expired.</h4>
                            <h4>Please contact administrator.</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>